<template>
    <div style="background: #EFEFEF; width: 100%; height: 100vh;position: absolute;">
        <v-btn v-if="usuario != null" color="success" class="mx-5 my-5" :to="{name: 'cpanel'}">
            Products Panel
        </v-btn>
        <v-card v-if="usuario === '' || usuario === null || usuario === undefined" width="500" flat class="cardss">
            <v-card-text class="text-center green white--text headline pa-5">
                <h3>
                    Login
                </h3>
            </v-card-text>
            <v-card-text class="white gray--text">
                <v-form @submit.prevent="loginUser(
                    {
                        email: useremail,
                        password: userpass
                    }
                )">
                <v-layout justify-center column>
                    <v-flex xs12>
                        <label>
                            <span class="black--text">
                             <strong>Email</strong> 
                            </span>  <br>
                            <input v-model="useremail" type="email" required class="inputTxt">
                        </label>
                    </v-flex>
                    <v-flex xs12>
                        <label>
                            <span class="black--text">
                             <strong>Password</strong> 
                            </span>  <br>
                            <input v-model="userpass" type="password" required class="inputTxt">
                        </label>
                    </v-flex>
                    <v-flex xs12>
                        <v-btn outlined block type="submit" class="mt-4 orange gray--text custom">
                            Login
                        </v-btn>
                    </v-flex>
                    </v-layout>
                </v-form>
            </v-card-text>
        </v-card>
    </div>
</template>

<style>
    .custom {
        text-transform: none;
    }
    .inputTxt {
    background-color: #fff;
    height: 31px;
    padding: 3px 7px;
    line-height: normal;
    color: #333;
    border: solid #a6a6a6 1px;
    border-top-color: #949494;
    border-radius: 3px;
    box-shadow: 0 1px 0 rgba(255,255,255,.5), 0 1px 0 rgba(0,0,0,.07) inset;
    outline: 0;
    font-weight: 500;
    text-align: center;
    width: 100%;
}
.inputTxt:focus {
    border-color: #e77600;
    box-shadow: 0 0 3px 2px rgba(228,121,17,.5);
}
    .cardss {
        border-radius: 0%;
        margin: 50px auto;
        display: block;
    }
</style>

<script>
import { mapState, mapActions } from "vuex";
export default {
    
    data() {
        return {
            name: '', price: '', description: '', avalible: '', useremail: '', userpass: ''
        }
    },
    methods:{
        ...mapActions(['buscarImagen', 'uploadFiles', 'loginUser', 'cerrarSesion'])
    },
    computed: {
        ...mapState(['urlTemporal', 'usuario', 'file'])
    },

}
</script>